module.exports = __webpack_public_path__ + "img/y- (2).400b2005.png";